<template>
  <div class="map">
    <iframe
      ref="mapIframe"
      width="100%"
      height="800px"
      frameborder="0"
      @load="loaded"
      src="https://m.amap.com/picker/?key=bb7409257967da9aab704f474a48f504&jscode=e3dd11d125bdf105cac127732188c745"
    />
    <!-- </Drawer> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    window.addEventListener(
      'message',
      e => {
        console.log(e);
        let loc = e.data;
        if (!loc.location) {
          return;
        }
        const [longitude, latitude] = loc.location.split(',').map(parseFloat);
        this.$emit('setSite', {
          latlng: {
            lat: latitude,
            lng: longitude
          },
          poiaddress: loc.address,
          poiname: loc.name
        });
      },
      false
    );
  },
  methods: {
    loaded(e) {
      var iframe = this.$refs.mapIframe.contentWindow;
      iframe.postMessage('hello', 'https://m.amap.com/picker/');
    },
    closeMap() {
      this.$emit('closeMap');
    }
  }
};
</script>

<style lang="less" scoped></style>
